module.exports = __webpack_public_path__ + "static/24-897f8f106b4c9e920586d7cb44c3645d.jpg";